import { TaskTypeDefinition } from '@modules/TasksModule/types';
import CustomerTaskView from '@pages/agent/InboxPage/components/CustomerTaskView/CustomerTaskView';

const textTaskType: TaskTypeDefinition = {
  key: 'text',
  category: 'Text',
  categoryIcon: 'phone_iphone',
  types: ['text'],
  taskViewComponent: CustomerTaskView,
};

export default textTaskType;
